import { gql } from "gql";

export const SAVE_POST = gql(/* GraphQL */ `
  mutation SavePost($post: PostInput!, $commentsCount: Int! = 100) {
    savePost(post: $post) {
      ...BasePost
    }
  }
`);
